import EurekaMap from "../components/EurekaMap";
import EurekaHeader from "../components/EurekaHeader";
import footprint from "../assets/images/fitc/fitcFootprint.png";
import DuckAnimation from "../assets/animations/eureka_farm.json";
import water2 from "../assets/images/fitc/water3.png";
import DescriptionText from "../assets/images/fitc/fitcDescription.png";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PlayClip from "../assets/images/fitc/fitcPlayClip.svg";
import PauseClip from "../assets/images/fitc/fitcPauseClip.svg";
import AudioPlayer from "../assets/images/fitc/fitcAudioPlayer.png";
import YoutubePlayer from "../assets/images/fitc/fitcYoutubePlayer.png";
import ImagesIcon from "../assets/images/fitc/fitcImagesIcon.png";
import ExitIcon from "../assets/images/fitc/fitcExitIcon.png";
import { IconButton } from "@mui/material";
import React from "react";
import Lottie from "lottie-react";
import "../Master.sass";
import "./HomePage.sass";
import { getMap } from "../utilities/Requests";
import { APIResult } from "../config/ApiResults";
import { hasContent } from "../utilities/Utilities";

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      waterVal: 0, // Water animation initial value
      mapURL: "", //  Image URL of map
      mapPins: [], // Array of pins
      currentShowingSoundClips: [], // Array of audio clips
      isPlaying: [], // Audio Play
      currentShowingPin: null, //Pins to be shown
      autoShowPin: null, // Auto show pin
      isPlayingClips: [],
      currentYoutubeLink: "",
      currentShowingImages: [],
      currentImageSelected: "",
      toggleImageView: false,
      showPin: false,
    };

    this.audioClipURL = "";
    this.audio = new Audio();
    this.mapRef = React.createRef();

    this.exitShowPin = this.exitShowPin.bind(this);
  }
  // Runs on the start of the App
  componentDidMount() {
    // Use Effect
    const urlSearchParams = new URLSearchParams(window.location.search);
    const id = urlSearchParams.get("id");
    // console.log(id);
    this.performGetMap(id);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({
      currentHeight: window.innerHeight,
      currentWidth: window.innerWidth,
    });
  };

  async performGetMap(id = false) {
    // Get map from API
    var result = await getMap();

    if (result.status === APIResult.SUCCESS) {
      this.setState(
        {
          mapURL: result.map_image,
          mapPins: result.map_pins,
        },
        () => {
          // Callback function to set the current pin to be shown
          if (id) {
            this.handlePushUpWithId(id);
          }
        }
      );
    }
  }

  exitShowPin = () => {
    if(this.state.isPlaying){
      this.audio.pause();
      this.setState({
        isPlaying: false,
      });
    }
    this.setState({ showPin: false }, () => {
      setTimeout(() => {
        this.setState({
          currentShowingPin: null,
          currentYoutubeLink: "",
        });
      }, 500);
    });

    var iframes = document.querySelectorAll(".yt_player_iframe");
    iframes.forEach(iframe => {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"stopVideo","args":""}',
        "*"
      );
    });
  };

  // Call Pop-up Card Function by ID
  handlePushUpWithId = id => {
    this.state.mapPins.forEach(pin => {
      if (Number(pin.id) === Number(id)) {
        this.mapRef.current.navigateToPin(pin);
        this.handlePushUp(pin);
      }
    });
  };

  //Pop-up Card Function
  handlePushUp = pin => {
    
    let youtubeLink = pin.youtube.split("v=")[1];
    this.setState({
      currentShowingPin: pin, // Set current pin to be shown
      showPin: true,
      currentShowingSoundClips: pin.sound_clip, // Set current audio to be played
      currentYoutubeLink: youtubeLink,
      currentShowingImages: pin.images,
    });

    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set("id", pin.id);
    const newUrl = `${window.location.pathname}?${urlSearchParams.toString()}`;
    window.history.pushState({ path: newUrl }, "", newUrl);

    window.gtag('event', 'page_view', {
      'page_title': pin.label,
      'page_location': newUrl
    });
  };

  toggleAudio = (audioURL, index, audioLabel = "") => {
    
    if (audioURL !== this.audioClipURL) {
      if (index !== this.index) {
        this.audio.pause();
        this.setState({
          isPlaying: false,
        });
      }
      this.audioClipURL = audioURL;
      this.audio = new Audio(audioURL);
      this.audio.play();
      this.setState({
        isPlaying: true,
      });
      //console.log("audio  " + audioLabel);
      if(audioLabel){
        window.gtag('event', 'audioplay', {
          'audio_loc': audioLabel
        });
      }
    } else {
      if (this.audio.paused) {
        this.audio.play();
        this.setState({
          isPlaying: true,
        });
      } else {
        this.audio.pause();
        this.setState({
          isPlaying: false,
        });
      }
    }
  };

  getWater(type = "water3") {
    var h = 200;
    return (
      <div className={type}>
        <img
          className="water-img"
          src={water2}
          alt="water2"
          style={{
            width: "100vw",
            height: `${h}px`,
            transform: `translateY(${type === "water3" ? -2 : 0}%)`,
          }}
        />
        <img
          className="water-img"
          src={water2}
          alt="water2"
          style={{
            width: "100vw",
            height: `${h}px`,
            transform: `scaleX(-1) translateY(${type === "water3" ? -2 : 0}%)`,
          }}
        />
        <img
          className="water-img"
          src={water2}
          alt="water2"
          style={{
            width: "100vw",
            height: `${h}px `,
            transform: `translateY(${type === "water3" ? -2 : 0}%)`,
          }}
        />
      </div>
    );
  }

  getAudioPlayerButton(clip) {
    //console.log(this.state.isPlaying, this.audioClipURL, clip.url);
    if (
      this.state.isPlaying &&
      this.audioClipURL === clip.url &&
      clip.url !== ""
    ) {
      return PauseClip;
    }
    return PlayClip;
  }

  render() {
    return (
      //Footprints in the background
      <div
        className="body-container"
        style={{
          background: "#1B4825",
          backgroundImage: `url(${footprint})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          width: this.state.currentWidth,
          height: this.state.currentHeight,
          overflow: "hidden",
        }}>
        {this.state.toggleImageView ? (
          <div
            style={{
              height: "100vh",
              width: "100%",
              background: "#000000BF",
              position: "absolute",
              zIndex: 99,
              top: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              aspectRatio: "16/9",
            }}
            onClick={() => {
              this.setState({ toggleImageView: false });
            }}>
            <div
              style={{
                padding: "1em",
                borderRadius: "4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                aspectRatio: "16/9",
                width: `100%`,
                objectFit: "contain",
                zIndex: 99,
              }}>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  padding: "1em",
                  cursor: "pointer",
                }}>
                <img className="exit-button" src={ExitIcon} alt="" />
              </div>
              <img
                style={{
                  height: "auto",
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  borderRadius: "4px",
                }}
                src={this.state.currentImageSelected}
                alt=""
              />
            </div>
          </div>
        ) : null}
        {/* Loading modal */}
        <div
          className="modal-background"
          onClick={this.exitShowPin}
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            background: "black",
            zIndex: 5,
            opacity: !this.state.showPin ? 0 : 0.5,
            transition: "0.5s ease-in-out",
            pointerEvents: !this.state.showPin ? "none" : "auto",
          }}></div>
        {/* Header */}
        <EurekaHeader />
        {/* Map */}
        <EurekaMap
          ref={this.mapRef}
          mapURL={this.state.mapURL}
          mapPins={this.state.mapPins}
          handlePushUp={this.handlePushUp}
          currentHeight={this.state.currentHeight}
        />
        <div
          className="context-container"
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            transform: `translateX(${this.state.waterVal}vw)`,
          }}>
          <div
            onClick={this.exitShowPin}
            style={{
              display: "flex",
              justifyContent: "center",
              pointerEvents: "none",
              position: "relative",
            }}>
            {/*Play duck animation*/}

            {this.getWater("water5")}
            {this.getWater("water4")}
            <Lottie
              animationData={DuckAnimation}
              loop={true}
              style={{ width: 128, transform: "translateY(5px)" }}
            />
            {this.getWater()}
          </div>
          <div className={`bottom-card-collapse ${this.state.showPin && "in"}`}>
            {/* Background of PopUp */}
            <div
              style={{
                backgroundImage:
                  "linear-gradient(180deg, rgb(16, 186, 190), #006E71)",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                paddingTop: "10px",
                marginTop: "4px",
              }}>
              <div
                style={{
                  width: 512,
                  maxWidth: "85%",
                  padding: 16,
                  background: "#F4F07C",
                  borderRadius: "16px 16px 0 0",
                  maxHeight: 600,
                  overflow: "auto",
                  pointerEvents: "auto",
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  gap: "1em",
                  flexDirection: "column",
                }}>
                {this.state.currentShowingPin !== null && (
                  <div
                    style={{
                      justifyContent: "space-between",
                      display: "flex",
                      color: "#1B4825",
                      width: "100%",
                    }}>
                    <div
                      className="row"
                      style={{
                        width: "100%",
                      }}>
                      {/* Label Text*/}
                      <div className="col-10 label-text pb-0">
                        {this.state.currentShowingPin.label !== ""
                          ? this.state.currentShowingPin.label
                          : "-"}
                      </div>
                      {/* Close Icon*/}
                      <div className="col-2 justify-end">
                        <IconButton
                          onClick={this.exitShowPin}
                          style={{
                            padding: 0,
                          }}>
                          <CloseOutlinedIcon />
                        </IconButton>
                      </div>
                      {/* Sub-Label Text*/}
                      {hasContent(this.state.currentShowingPin.sub_label) && (
                        <div className="col-12 sublabel-text">
                          {this.state.currentShowingPin.sub_label !== ""
                            ? this.state.currentShowingPin.sub_label
                            : "-"}
                        </div>
                      )}
                      {/* Description Img */}
                      {hasContent(this.state.currentShowingPin.description) && (
                        <>
                          <div className="" style={{ width: 48 }}>
                            <img
                              src={DescriptionText}
                              alt="Description"
                              style={{
                                width: 36,
                                height: 36,
                              }}
                            />
                          </div>
                          {/* Description Text*/}
                          <div className="col-10 label-description pb-24">
                            {this.state.currentShowingPin.description !== ""
                              ? this.state.currentShowingPin.description
                              : "-"}
                          </div>
                        </>
                      )}

                      {this.state.currentShowingSoundClips &&
                      this.state.currentSoundClips !== "" &&
                      this.state.currentShowingPin.sound_clip.length > 0 ? (
                        <div>
                          {/*Sound Clips */}
                          <div
                            className=""
                            style={{
                              display: "grid",
                              gridTemplateColumns: "48px 1fr",
                              justifyContent: "center",
                              alignItems: "flex-start",
                            }}>
                            <div
                              className=""
                              style={{
                                width: 48,
                                height: 52,
                                display: "flex",
                                alignItems: "center",
                              }}>
                              <img
                                src={AudioPlayer}
                                alt="AudioPlayer"
                                style={{
                                  width: 36,
                                  height: 36,
                                  boxSizing: "border-box",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: 12,
                                overflow: "scroll",
                                flexWrap: "wrap",
                              }}>
                              {/* Sound Clip IMG */}
                              {this.state.currentShowingSoundClips.map(
                                (clip, i) => {
                                  if (clip.url === "") {
                                    return null;
                                  }
                                  return (
                                    <div
                                      className="button-play-clip"
                                      key={`sound-clips-${clip.id}-${i}`}>
                                      {clip.label}
                                      <img
                                        className="button-play-clip-icon"
                                        src={this.getAudioPlayerButton(clip)}
                                        alt=""
                                        onClick={() =>
                                          this.toggleAudio(clip.url, i, this.state.currentShowingPin.label + " " + clip.label)
                                        }
                                        style={{ cursor: "pointer" }}
                                      />
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          {/* Sound Clip IMG */}
                          <div className="" style={{ width: 48 }}>
                            <img
                              src={AudioPlayer}
                              alt="AudioPlayer"
                              style={{
                                width: "100%",
                                height: 36,
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div className="col-10">
                            No sound clips available for the selected pin.
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {this.state.currentYoutubeLink !== undefined ? (
                  <div>
                    {/*Youtube Clips */}
                    <div
                      className=""
                      style={{
                        display: "grid",
                        gridTemplateColumns: "48px 1fr",
                        justifyContent: "center",
                        alignItems: "flex-start",
                      }}>
                      <div
                        className=""
                        style={{
                          width: 48,
                          height: 52,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <img
                          src={YoutubePlayer}
                          alt="Youtube"
                          style={{
                            width: 36,
                            height: 36,
                            boxSizing: "border-box",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: 12,
                          flexWrap: "wrap",
                        }}>
                        {/* Youtube */}
                        <div style={{ width: "100%", borderRadius: "4px" }}>
                          <iframe
                            style={{ borderRadius: "4px" }}
                            width="100%"
                            height="100%"
                            src={`https://www.youtube.com/embed/${this.state.currentYoutubeLink}?autoplay=1?`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {this.state.currentShowingImages.length > 0 ? (
                  <div>
                    {/*Youtube Clips */}
                    <div
                      className="section_img"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "48px 1fr",
                        justifyContent: "center",
                        alignItems: "flex-start",
                      }}>
                      <div
                        className=""
                        style={{
                          width: 48,
                          height: 52,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <img
                          src={ImagesIcon}
                          alt="Images"
                          style={{
                            width: 36,
                            height: 36,
                            boxSizing: "border-box",
                          }}
                        />
                      </div>
                      <div
                        className="point_img_container">
                        {/* Image Clip IMG */}

                        {this.state.currentShowingImages.map((images, i) => {
                          return (
                            <div
                            className="point_img_container"
                             
                              key={`images-${images}-${i}`}
                              onClick={() => {
                                this.setState({
                                  currentImageSelected: images.url,
                                  toggleImageView: true,
                                });
                              }}>
                              <img
                              className="point_img"
                                
                                src={images.url}
                                alt=""
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            {/* <div
              style={{
                position: "absolute",
                top: 0,
                height: "100%",
                width: "100%",
              }}>
              <div style={{ position: "relative", height: "100%" }}>
                {this.getWater("water5")}
                {this.getWater("water4")}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default HomePage;
